import CancerPage from "../components/CancerPage";

const stepsText = [
  "Following the detection of a suspicious polyp or mass during colposcopy, several crucial steps are taken.",
  "Biopsy and Histopathological Confirmation: A biopsy of the suspicious area is performed to confirm the presence of cancerous or pre-cancerous cells.",
  "Imaging for Staging: CT scan (Computed Tomography) to assess the extent of the disease.",
  "PET scan (Positron Emission Tomography): To identify if cancer has spread to other lymph nodes or organs.",
  "Blood Tests: To assess general health and look for tumor markers.",
  "Endoscopic Ultrasound (EUS) or Transrectal Ultrasound: To evaluate the depth of tumor invasion and lymph node involvement.",
];

export default function CervixCancerPage() {
  return (
    <CancerPage
      cancerName="Cervix Cancer"
      scanType="Colposcopic images"
      analysisText="Based on the colonoscopy image, Med-X's system has detected a polyp-like mass within the cervical region. The green outline highlights this suspicious area, functioning as a lesion segmentation. This automated analysis identifies the location of the lesion and is a critical first step. While this initial finding is highly suggestive, a definitive diagnosis requires further testing to confirm the presence of cancerous cells and determine the extent of the disease."
      stepsTitle="Necessary Steps Following an Abnormal Colonoscopy:"
      stepsText={stepsText}
    />
  );
}
